import * as Cookies from 'js-cookie';
import * as CryptoJS from 'crypto-js';
import env from './env';
import getAppURL from './getAppURL';

const passPhrase = env('POS_PASSPHRASE') || '';

/**
 * Cookie keys are; _pos_tokid(token id) | _pos_usrid(user id) | _pos_store(store)
 * @param key
 * @param value
 * @param expires
 */
const setCookie = (key: string, value: string, expires?: number) => {
  const cipheredValue = CryptoJS.AES.encrypt(value, passPhrase).toString();

  // const appURL = new URL(getAppURL());

  // let domain = appURL.hostname.replace('www.', '');

  // domain = domain === 'localhost' ? '' : domain;

  // { ...(domain && { domain }) }

  if (env('POS_ENV') === 'development') {
    Cookies.set(key, cipheredValue);
    return;
  }

  if (env('POS_ENV') === 'staging') {
    Cookies.set(key, cipheredValue);
    return;
  }

  const options: Cookies.CookieAttributes = {
    ...(expires && { expires }),
    sameSite: 'Lax',
    secure: true,
  };

  Cookies.set(key, cipheredValue, options);
};

export default setCookie;
